/**
 * 埋点上传
 * @param data object
 * 使用:
 * import { useModel } from 'umi';
 * const { uploadData } = useModel('useUploadDataModel');
 * uploadData({ a: 1, b})
 * */

import { request } from 'umi';
import { useCallback } from 'react';
import env, { isInWechat } from '@/utils/env';

// 埋点上传请求
export function fetchUploadData(data = {}) {
  // let url = `https://blackpearltest.4009515151.com/interfaces/analytic`;
  // const url = `https://neighbourtest.4009515151.com/interfaces/analytic`;
  // console.log('env:', env.TYREAL_API_HOST);
  const url = `${env.BLACKPEARL_HOST}/interfaces/analytic`;
  return request(url, {
    method: 'post',
    data: {
      from: isInWechat ? 'mp_h5' : 'h5',
      business: 'nova',
      env: env.ENV, // 环境
      ...data,
    },
    skipErrorHandler: true,
  }).catch(() => {
    // do nothing
  });
}

interface ILog {
  accountId: string;
  goodsId: number;
}

// 友邻市集	友邻市集首页	曝光友邻市集首页		H5	计数事件		home_render
const logHomeRender = () => {
  fetchUploadData({ statistics_name: 'home_render' });
};

// 友邻市集	友邻市集首页	友邻市集首页-点击爆款		H5	参数： 1、accountId： 用户id 2、item_style：'item_click' 3、 module_id: 模块id home_atmosphere_card_click
const logHomeAtmosphereCardClick = ({
  accountId,
  moduleId,
}: {
  accountId: string;
  moduleId: string;
}) => {
  fetchUploadData({
    statistics_name: 'home_atmosphere_card_click',
    item_style: 'item_click',
    accountId,
    module_id: moduleId,
  });
};

// 友邻市集	友邻市集首页	友邻市集首页-点击爆款		H5	参数： 1、accountId： 用户id 2、item_style：'item_click' 3、 item_id：商品的ID		home_week_card_click
const logHomeWeekCardClick = ({ accountId, goodsId }: ILog) => {
  fetchUploadData({
    statistics_name: 'home_week_card_click',
    item_style: 'item_click',
    accountId,
    item_id: goodsId,
  });
};
// 友邻市集	友邻市集首页	友邻市集首页-点击邻居热购		H5	参数： 1、accountId： 用户id 2、item_style：'item_click' 3、 item_id：商品的ID		home_hot_card_click
const logHomeHotCardClick = ({ accountId, goodsId }: ILog) => {
  fetchUploadData({
    statistics_name: 'home_hot_card_click',
    item_style: 'item_click',
    accountId,
    item_id: goodsId,
  });
};

// 友邻市集	友邻市集首页	友邻市集首页-点击banner		H5	计数事件		home_banner_card_click
const logHomeBannerCardClick = () => {
  fetchUploadData({
    statistics_name: 'home_banner_card_click',
  });
};
// 友邻市集	友邻市集首页	友邻市集首页-点击分类icon		H5	计数事件		home_navigation_card_click 参数：1、jumpType 跳转类型 1分类 2 专题 3 分类 2、 jumpUrl 跳转URL 3、ids 调整类型为分类时的id数组
const logHomeNavigationCardClick = ({
  jumpType,
  jumpUrl,
  linkIds,
}: {
  jumpType: number;
  jumpUrl: string;
  linkIds?: string;
}) => {
  fetchUploadData({
    statistics_name: 'home_navigation_card_click',
    jumpType,
    jumpUrl,
    linkIds: linkIds || undefined,
  });
};
// 友邻市集	友邻市集首页	友邻市集首页-点击精选专题		H5	计数事件		home_theme_card_click
const logHomeThemeCardClick = ({ subjectId }: { subjectId: number }) => {
  fetchUploadData({
    statistics_name: 'home_theme_card_click',
    subjectId: subjectId || undefined,
  });
};

// 友邻市集	友邻市集首页	友邻市集首页-点击分类icon		H5	计数事件		home_three_pic_card_click 参数：1、jumpType 跳转类型 1分类 2 专题 3 分类 2、 jumpUrl 跳转URL 3、ids 调整类型为分类时的id数组
const logHomeThreePicCardClick = ({
  jumpType,
  jumpUrl,
  linkIds,
}: {
  jumpType: number;
  jumpUrl: string;
  linkIds?: string;
}) => {
  fetchUploadData({
    statistics_name: 'home_navigation_card_click',
    jumpType,
    jumpUrl,
    linkIds: linkIds || undefined,
  });
};
// 友邻市集	友邻市集首页	友邻市集首页-点击瀑布流商品		H5	参数： 1、accountId： 用户id 2、item_style：'item_click' 3、 item_id：商品的ID		home_goods_list_click
const logHomeGoodsListClick = ({ accountId, goodsId }: ILog) => {
  fetchUploadData({
    statistics_name: 'home_goods_list_click',
    item_style: 'item_click',
    accountId,
    item_id: goodsId,
  });
};
// 友邻市集	友邻市集首页	友邻市集首页-点击回到顶部按钮		H5	计数事件		home_to_top_click
const logHomeToTopClick = () => {
  fetchUploadData({
    statistics_name: 'home_to_top_click',
  });
};

interface IData {
  readonly id?: number;
  readonly token?: string;
  statistics_name?: string;
  ip?: string;
  // 字符串索引签名, 用任意字符串来索引 IData，这样就支持多个属性了
  [x: string]: any;
}

export default function useUploadDataModel() {
  const uploadData = useCallback((data: IData = {}) => {
    fetchUploadData(data);
  }, []);
  return {
    logHomeGoodsListClick,
    logHomeBannerCardClick,
    logHomeHotCardClick,
    logHomeNavigationCardClick,
    logHomeThreePicCardClick,
    logHomeRender,
    logHomeThemeCardClick,
    logHomeWeekCardClick,
    logHomeToTopClick,
    logHomeAtmosphereCardClick,
    uploadData,
  };
}
